import * as v from '@badrap/valita'
import { api } from 'src/api'

export const listActiveUsers = (params: {
  organization: string
  username: string
}) =>
  api({
    schema: v
      .object({
        result: v.literal('OK'),
        users: v.array(
          v.object({
            username: v.string(),
            creationtime: v.number(),
            lastActivity: v.number(),
          }),
        ),
      })
      .chain((data) =>
        v.ok([
          ...data.users.sort((a, b) => a.username.localeCompare(b.username)),
        ]),
      ),
    method: 'POST',
    url: '/listactiveusers',
    body: params,
    withAuth: true,
  })

export const logoutUser = (params: {
  username: string
  organization: string
  usernameforlogout: string
}) =>
  api({
    schema: v.object({
      result: v.literal('OK'),
    }),
    method: 'POST',
    url: '/logoutuserprovisioning',
    body: params,
    withAuth: true,
  })
